import * as React from "react";
import { Context } from "./_context";
export const TrafficIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13.657 3.013a1 1 0 0 1 .788.662L19.713 19H21.5v2h-19v-2h1.787L9.555 3.675l.062-.145A1 1 0 0 1 10.5 3h3l.157.013ZM9.322 10.5 6.4 19h11.2l-2.922-8.5H9.322Zm.688-2h3.98L12.787 5h-1.574L10.01 8.5Z", fill: "currentColor" }));
  return iconset[size];
};
TrafficIcon.iconId = "R0hRNb";
